/**
 * 引导页顶部居中欢迎标题。
 * Screen-space DOM 覆盖层，不跟随 head yaw 视差，永远清晰可读。
 */
export function WelcomeTitle() {
  return (
    <div className="welcome-title">
      <h1>Welcome to BNGU</h1>
      <p>请捏住食指和大拇指，将金矿石兑换进底部方框</p>
    </div>
  )
}
